<tool-form formTitle="FTIC Course DWF & APR Filter">
  <form
    [formGroup]="fticCourseForm"
    (ngSubmit)="submitForm()"
    class="form-content"
  >
    <mat-form-field class="filter-form-field">
      <mat-label>Select a Cohort</mat-label>
      <mat-select
        formControlName="cohort"
        required
        (selectionChange)="updateFilters('cohort')"
      >
        <mat-option
          *ngFor="let cohort of fticCourseFilters.cohorts"
          [value]="cohort"
          >{{ cohort }}</mat-option
        >
      </mat-select>
      <mat-error *ngIf="this.fticCourseForm.controls['cohort'].invalid"
        >You must enter a cohort</mat-error
      >
      <progress-bar
        *ngIf="fieldsToDisable.includes('cohort') && filtersUpdating"
      ></progress-bar>
    </mat-form-field>

    <mat-form-field class="filter-form-field">
      <mat-label>Select a College</mat-label>
      <mat-select
        formControlName="college"
        required
        (selectionChange)="handleCollegeChange()"
      >
        <mat-option
          *ngFor="let college of fticCourseFilters.colleges"
          [value]="college"
          >{{ college }}</mat-option
        >
      </mat-select>
      <mat-error *ngIf="this.fticCourseForm.controls['college'].invalid"
        >You must select a college</mat-error
      >
      <progress-bar
        *ngIf="fieldsToDisable.includes('college') && filtersUpdating"
      ></progress-bar>
    </mat-form-field>

    <mat-form-field class="filter-form-field">
      <mat-label>Select a Program</mat-label>
      <mat-select
        formControlName="program"
        required
        (selectionChange)="updateFilters('program')"
      >
        <mat-option
          *ngFor="let program of fticCourseFilters.programs"
          [value]="program.name"
          >{{ program.name }}</mat-option
        >
      </mat-select>
      <mat-error *ngIf="this.fticCourseForm.controls['program'].invalid"
        >You must enter a program</mat-error
      >
      <progress-bar
        *ngIf="fieldsToDisable.includes('program') && filtersUpdating"
      ></progress-bar>
    </mat-form-field>

    <div class="form-slider-container">
      <mat-label class="form-slider-text-label">High School GPA</mat-label>
      <mat-slider class="form-slider" min="0" max="5" step="0.25">
        <input
          value="0"
          matSliderStartThumb
          #sliderStartHS
          formControlName="hs_gpa_lower"
        />
        <input
          value="5"
          matSliderEndThumb
          #sliderEndHS
          formControlName="hs_gpa_upper"
        />
      </mat-slider>
      <div class="form-slider-value-label-container">
        <label>{{ sliderStartHS.value }}</label>
        <label>{{ sliderEndHS.value }}</label>
      </div>
    </div>
    <div style="margin-bottom: 20px">Replaced NAs with 0.00</div>

    <mat-form-field class="filter-form-field">
      <mat-label>Select a UWF Year</mat-label>
      <mat-select
        formControlName="uwf_year"
        required
        (selectionChange)="updateFilters('uwf_year')"
      >
        <mat-option
          *ngFor="let uwfYear of fticCourseFilters.uwf_years"
          [value]="uwfYear"
          >{{ uwfYear }}</mat-option
        >
      </mat-select>
      <mat-error *ngIf="this.fticCourseForm.controls['uwf_year'].invalid"
        >You must enter a value</mat-error
      >
      <progress-bar
        *ngIf="fieldsToDisable.includes('uwf_year') && filtersUpdating"
      ></progress-bar>
    </mat-form-field>

    <mat-form-field class="filter-form-field">
      <mat-label>Select a Term</mat-label>
      <mat-select formControlName="terms" required multiple>
        <mat-option
          *ngFor="let term of fticCourseFilters.terms"
          [value]="term.value"
          >{{ term.text }}</mat-option
        >
      </mat-select>
      <progress-bar
        *ngIf="fieldsToDisable.includes('terms') && filtersUpdating"
      ></progress-bar>
    </mat-form-field>

    <mat-form-field class="filter-form-field">
      <mat-label>Select a Course Number</mat-label>
      <input
        type="text"
        matInput
        formControlName="course"
        [matAutocomplete]="auto"
        required
      />
      <button
        *ngIf="fticCourseForm.value.course"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        (click)="fticCourseForm.patchValue({ course: '' })"
      >
        <i class="fas fa-times-circle"></i>
      </button>
      <mat-autocomplete #auto="matAutocomplete">
        <cdk-virtual-scroll-viewport
          class="autocomplete-test-viewport"
          [ngStyle]="{ height: courseSelectHeight }"
          itemSize="25"
        >
          <mat-option
            *cdkVirtualFor="let course of filteredCourses"
            [value]="course"
            class="autocomplete-item"
          >
            {{ course }}
          </mat-option>
        </cdk-virtual-scroll-viewport>
      </mat-autocomplete>
      <mat-error *ngIf="this.fticCourseForm.controls['course'].invalid"
        >You must enter a value</mat-error
      >
      <progress-bar
        *ngIf="fieldsToDisable.includes('course') && filtersUpdating"
      ></progress-bar>
    </mat-form-field>

    <tool-form-action-button
      text="Submit"
      (onClick)="closeDialog()"
      [disabled]="!fticCourseForm.valid"
    ></tool-form-action-button>
  </form>
</tool-form>
